
<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>   
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>        
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmDelete(row_index, delete_id)">Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <!-- <v-dialog v-model="dialog" persistent max-width="800px">
      <v-btn color="primary" dark slot="activator" class="mb-2">New Sub-Menu</v-btn> -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12 sm6 md3>
                <!-- <v-text-field label="Menu id" v-model="formSchema.menu_id"></v-text-field> -->
                <v-autocomplete
                label="Select Menu"
                item-text="menu_name"
                item-value="id"
                v-model="formSchema.menu_id"
                :items="menuList"                             
                :rules="[v => !!v || 'Manu name is required !']"
                required
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 md3>
                <v-text-field label="Submenu name" 
                v-model="formSchema.submenu_name"
                :rules="[v => !!v || 'Submanu name is required !']"
                required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md3>
                <v-text-field label="Sl no" v-model="formSchema.sl_no"
                :rules="[v => !!v || 'Serial no is required !']"
                required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md3>
                <v-text-field label="Description" v-model="formSchema.description"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md3>
                <v-text-field label="Controller Name" v-model="formSchema.controller_name"
                :rules="[v => !!v || 'Controller name is required !']"
                required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md3>
                <v-text-field label="Css class" v-model="formSchema.css_class"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md3>
                <v-text-field label="Route" v-model="formSchema.route"
                :rules="[v => !!v || 'Route is required !']"
                required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md3>
                <v-text-field label="Url" v-model="formSchema.url"
                :rules="[v => !!v || 'URL is required !']"
                required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-checkbox v-model="formSchema.active" label="Active"></v-checkbox>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
          <v-icon>save</v-icon> {{addUpdateBtn}}</v-btn>
          <v-btn color="error" @click.native="reset">
            <v-icon>refresh</v-icon> Reset
          </v-btn>
          <v-btn color="blue" @click.native="close"><v-icon>close</v-icon> Close</v-btn>
        </v-card-actions>

      </v-card>
    <!-- </v-dialog> -->


    <v-card-title>
      <h2> Submenu Data</h2>
      <v-spacer></v-spacer>
      <v-text-field
      append-icon="search"
      label="Search"
      single-line
      hide-details
      v-model="search"
      ></v-text-field>
    </v-card-title>

    <v-data-table
        v-bind:headers="headers"
        v-bind:items="items"
        v-bind:search="search"
        v-bind:pagination.sync="pagination"
        :total-items="totalItems"
        :loading="loading"
        class="elevation-1"
        >

    <template slot="items" slot-scope="props">

      <td class="text-xs-left">{{ props.item.menu_name }}</td>
      <td class="text-xs-left">{{ props.item.submenu_name }}</td>
      <td class="text-xs-left">{{ props.item.sl_no }}</td>
      <td class="text-xs-left">{{ props.item.controller_name }}</td>
      <td class="text-xs-left">          
        <span v-if="props.item.active" class="active">Yes</span>           
        <span v-else class="in-active">No</span>            
      </td>     
     <td class="justify-center layout px-0">
      <v-btn icon class="mx-0" @click="editItem(props.index, props.item)">
        <v-icon color="teal">edit</v-icon>
      </v-btn>
      <v-btn icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
        <v-icon color="pink">delete</v-icon>
      </v-btn>
    </td>
  </template>
  <template slot="footer">
    <td colspan="100%">
      <strong>This is an extra footer</strong>
    </td>
  </template>
  <template slot="no-data">
    <v-btn color="primary" @click="getDataFromApi()">Reset</v-btn>
  </template>
</v-data-table>


</div>
</template>

<script>
  const commonService = require('../../services/common.service');
  export default {
    data: () => ({
      valid: true,

      dialog: false,    

      totalItems: 0,      
      loading: true,     
      pagination: {
        sortBy: 'id',
        descending: true,
      },
      search:'',      
      headers: [

      {
        text: 'Menu Name',
        align: 'left',
        value: 'menu_name'
      },

      { text: 'Submenu name', align: 'left', value: 'submenu_name' },
      { text: 'Sl no', align: 'left', value: 'sl_no' },
      { text: 'Controller Name', value: 'controller_name' },
      {
        text: 'Active',
        align: 'left',
        value: 'avtive'
      },
      { text: 'Action', value: '' },

      ],
      items: [],
      item: {           
        edit: false,       
        submenu_name: '',             
        sl_no: '',             
        description: '',
        controller_name:'',             
        css_class: '',             
        route: '',             
        url: '',             
      },
      delete_id:'',
      row_index:'',
      dialog2: false,
      menuList:[],

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

    }),


    created () {

      let root = this;
      commonService.getAllData('main-manu-list').then( res => {        
        root.menuList = res.data
      });
    },
    mounted () {
      this.loadData();
      this.SnackbarVal.message = 'Data loading!';
      this.SnackbarVal.snackbar = true;
      this.SnackbarVal.color = "success"; 
    },
    watch: {      
    },
    methods: {

      loadData: function () {
        commonService.getAllData('sub-manu').then(res => {    
          this.items = res.data;
          this.loading = false;
        });
      },

      validateBeforeSubmit(e) {
        if (this.$refs.form.validate()) {
          this.submitForm();
        }
      },

      submitForm(e) {

        var formSchema = this.formSchema
        var root = this

        this.$validator.validateAll().then((result) => {  

          if ( formSchema.id > 0 )
          {                     
            commonService.updateFormData(formSchema, 'sub-manu').then(res => {
              if(res.status == 1)
              {          
                this.$set(this.items, this.row_index, {...res.data})
                this.SnackbarVal.color = "success"; 
              }
              else
              {
                this.SnackbarVal.color = "error"; 
              } 
              this.SnackbarVal.message = res.message;
              this.SnackbarVal.snackbar = true;
              this.close();               
            });
          }
          else
          {
            commonService.insertFormData(formSchema, 'sub-manu').then(res => {
              if(res.status == 1)
              {          
                this.items.unshift({...res.data});
                this.SnackbarVal.color = "success"; 
              }
              else
              {
                this.SnackbarVal.color = "error"; 
              } 
              this.SnackbarVal.message = res.message;
              this.SnackbarVal.snackbar = true; 
              this.close();
            });
          } 
        });

      },

      formReset: function(){        
        this.$store.commit('SYSSUBMENU_UNSET_ALL_STATE')
        //this.$store.commit('SYSSUBMENU_UNSET_SCHEMA')
      },      


      editItem (index, item) {
        this.row_index = index;
        this.$store.commit('SYSSUBMENU_SET_SCHEMA', {...item})
        /*this.item.edit = true
        this.dialog = true*/
        window.scrollTo({
          top: 0,
          left: 100,
          behavior: "smooth"
        });
      },

      deleteItem (index,id) {          
        this.row_index = index;
        this.delete_id = id;
        this.dialog2 = true;
      },

      confirmDelete(row_index,id){                    
        var root = this;
        //this.$store.dispatch('delete_SYSSUBMENU',{id}).then(() => {
        commonService.deleteRow(id, "sub-manu").then(res => {               
          if (res.status == 1) {          
            this.items.splice(row_index, 1)
            this.SnackbarVal.color = "success";
          } 
          else{
            this.SnackbarVal.color = "error";
          }                 
          this.SnackbarVal.message = res.message
          this.SnackbarVal.snackbar = true;
          this.dialog2 = false

        }).catch((err) => {
          console.log(err)
        });       
      },

      close () {
        //this.formReset()
        this.$refs.form.reset();
        this.item.edit = false
        /*this.dialog = false
        this.dialog2 = false*/
        //this.loadData();

        window.scrollTo({
          left: 0,
          top:
          document.body.scrollHeight || document.documentElement.scrollHeight,
          behavior: "smooth"
        });
      },


      save () {
        if (this.item.edit) {
          this.item.edit = false
        } else {
          this.items.push(this.item)
        }
        this.dialog = false
      }
    },

    computed: {
      formTitle () {
        return this.formSchema.id ? 'Edit Sub-Menu' : 'New Sub-Menu'
      },

      addUpdateBtn() {
        return this.formSchema.id > 0 ? "Update" : "Save";
      },

      formSchema(){
        return this.$store.getters.get_SYSSUBMENU_Schema ;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Submenu/sysSubmenu_table.vue